export default "__VITE_ASSET__18f4897c__"